import { ReactElement } from "react";
import { Container, ContainerProps } from "@chakra-ui/react";

export function ContentContainer({
  children,
  ...props
}: ContainerProps): ReactElement {
  return (
    <Container
      w="full"
      maxW="container.sm"
      display="flex"
      flexDirection="column"
      {...props}
    >
      {children}
    </Container>
  );
}
